import { getData } from '../get-table'

export async function getPrefixes(type: string): Promise<any> {
  // TODO: Add countryId to the query
  const response: any = await getData({
    tables: ['pg_prefixes'],
    fields: [
      'prefixes.id',
      'prefixes.code',
      'prefixes.name',
      'prefixes.description',
      'prefixes.field',
      'prefixes.countries',
      'prefix_types.name as type'
    ],
    join: [
      'INNER JOIN prefix_types ON prefixes.prefix_type_id = prefix_types.id'
    ],
    modifier: ['order by prefix_types.name desc'],
    where: [
      `prefix_types.name LIKE '%${type}%'`,
      'prefixes.is_deleted = false',
      'prefixes.is_inactive = false',
      '(countries is null or jsonb_exists(countries, :countryId))'
    ]
  })
  return response[0].results
}

export async function getSavedFormulas(): Promise<any> {
  const response: any = await getData({
    tables: ['pg_saved_formulas'],
    fields: [
      'id',
      'code',
      'name',
      'description',
      'formula',
      `'Formula Guardada' as type`
    ],
    modifier: ['order by created_at desc'],
    where: ['is_inactive = false', `countries ? :countryId`]
  })
  return response[0].results
}
